<!-- Centered, borderless chat "terminal notice" (e.g. chat ended): a medallion-wrapped icon above a headline and an uppercase caption. Signals a chat's end state, distinct from the inline ChatStatusCard. -->

<script lang="ts" setup>
import type { Component } from 'vue';

// Props
interface Props {
  caption: string;
  headline: string;
  icon: Component;
}

defineProps<Props>();
</script>

<template>
  <div :class="css.notice">
    <div :class="css.medallion">
      <component
        :is="icon"
        :class="css.icon"
      />
    </div>

    <span :class="css.headline">{{ headline }}</span>
    <span :class="css.caption">{{ caption }}</span>
  </div>
</template>

<style lang="scss" module="css">
.notice {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: $spacing-10;
  padding: $spacing-10 $spacing-16;
  width: 100%;
}

.medallion {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  background: $color-white;
  border: 1px solid $color-doctor-200;
  border-radius: 50%;
}

.icon {
  width: 24px;
  height: 24px;
  color: $color-doctor-600;
}

.headline {
  font-size: $font-size-15;
  font-weight: $font-weight-600;
  color: $color-text;
  text-align: center;
}

.caption {
  font-size: $font-size-10;
  font-weight: $font-weight-700;
  letter-spacing: 0.7px;
  text-transform: uppercase;
  // Spec calls for $color-doctor-300, but that fails the mandatory WCAG contrast check on white
  // (1.75:1). Use $color-doctor-600 — the same muted doctor tone the sibling ChatStatusCard uses
  // for its uppercase caption — which passes 4.5:1.
  color: $color-doctor-600;
  text-align: center;
}
</style>
